var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vue-template" },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "section-title" }, [
          _c("h2", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("catalog.Catalog"))),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "subtitle" }, [
            _vm._v(_vm._s(_vm.$t("catalog.subtitle"))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "catalog-filter" },
          [_c("information-box", { attrs: { category: _vm.currentCategory } })],
          1
        ),
      ]),
      _vm._v(" "),
      _c("category-filter", {
        attrs: { categories: _vm.categories, active_id: _vm.activeCategoryId },
        on: {
          "active-changed": _vm.activeCatChanged,
          "active-changed-last": _vm.scrollToProducts,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "catalog-list", attrs: { id: "catalog-list" } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "infinite-scroll",
                  rawName: "v-infinite-scroll",
                  value: _vm.loadMore,
                  expression: "loadMore",
                },
              ],
              staticClass: "container",
              attrs: {
                id: "catalog-container",
                "infinite-scroll-disabled": "busy",
                "infinite-scroll-distance": "600",
                "infinite-scroll-throttle-delay": "100",
              },
            },
            [
              _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.products, function (model) {
                  return _c(
                    "div",
                    { staticClass: "col-lg-4 col-md-6" },
                    [
                      _c("product-item", {
                        attrs: { item: model },
                        on: { "open-modal": _vm.modalData },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }